import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { Paper } from '@material-ui/core';
export const Menu = _ref => {
  let {
    children,
    selectProps,
    innerProps,
    getStyles
  } = _ref,
      props = _objectWithoutProperties(_ref, ["children", "selectProps", "innerProps", "getStyles"]);

  const _ref2 = getStyles('menu', props),
        {
    borderRadius,
    backgroundColor,
    boxShadow
  } = _ref2,
        style = _objectWithoutProperties(_ref2, ["borderRadius", "backgroundColor", "boxShadow"]);

  return /*#__PURE__*/React.createElement(Paper, _extends({
    square: true,
    style: _objectSpread(_objectSpread({}, style), {}, {
      minWidth: 'fit-content',
      zIndex: 10
    }),
    className: selectProps.classes.paper
  }, innerProps), children);
};